import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { StyledDialog, StyledPopupHeader, StyledPopupTitle, StyledPopupContent, StyledPopupFooter, StyledThirdBtn, StyledPopupRightFooterWrapper } from './Popup.styles.js';
import { ReactComponent as SvgIcCancel } from '../assets/img/ic_cancel.svg.js';
import Button from '../Button/Button.js';
const _excluded = ["open", "onClose", "size", "backgroundClose", "closeBtnShow", "title", "confirmText", "cancelText", "thirdBtnText", "onConfirm", "onCancel", "onThirdBtnClick", "sx", "children", "cancelProps", "confirmProps"];
function Popup(_ref) {
  let {
      open,
      onClose,
      size,
      backgroundClose,
      closeBtnShow,
      title,
      confirmText,
      cancelText,
      thirdBtnText,
      onConfirm,
      onCancel,
      onThirdBtnClick,
      sx,
      children,
      cancelProps,
      confirmProps
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  useTheme();
  const mappingSize = {
    sm: '520px',
    md: '640px',
    lg: '760px',
    xl: '880px'
  };
  const modalSize = mappingSize[size];
  const showFooter = onConfirm || onCancel || onThirdBtnClick;
  if (!open) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  return /*#__PURE__*/React__default.createElement(StyledDialog, _extends({
    open: open,
    onClose: backgroundClose ? onClose : false,
    maxWidth: modalSize,
    sx: sx
  }, otherProps), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: open ? 'flex' : 'none',
      flexDirection: 'column',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React__default.createElement(StyledPopupHeader, null, /*#__PURE__*/React__default.createElement(StyledPopupTitle, null, title), closeBtnShow && /*#__PURE__*/React__default.createElement(SvgIcCancel, {
    style: {
      width: '24px',
      height: '24px',
      cursor: 'pointer'
    },
    onClick: onClose
  })), /*#__PURE__*/React__default.createElement(StyledPopupContent, null, children), showFooter && /*#__PURE__*/React__default.createElement(StyledPopupFooter, null, /*#__PURE__*/React__default.createElement(StyledThirdBtn, {
    onClick: onThirdBtnClick
  }, onThirdBtnClick && thirdBtnText), /*#__PURE__*/React__default.createElement(StyledPopupRightFooterWrapper, null, onCancel && /*#__PURE__*/React__default.createElement(Button, _extends({
    onClick: onCancel,
    variant: 'outlined'
  }, cancelProps), cancelText), onConfirm && /*#__PURE__*/React__default.createElement(Button, _extends({
    onClick: onConfirm
  }, confirmProps), confirmText)))));
}
Popup.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  backgroundClose: PropTypes.bool,
  closeBtnShow: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  thirdBtnText: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  onThirdBtnClick: PropTypes.func,
  sx: PropTypes.shape({}),
  confirmProps: PropTypes.shape({}),
  cancelProps: PropTypes.shape({}),
  children: PropTypes.node
};
Popup.defaultProps = {
  open: false,
  onClose: () => {},
  size: 'sm',
  backgroundClose: true,
  closeBtnShow: true,
  title: 'Title',
  confirmText: 'Save',
  cancelText: 'Cancel',
  thirdBtnText: '',
  onConfirm: null,
  onCancel: null,
  onThirdBtnClick: null,
  sx: {},
  confirmProps: {},
  cancelProps: {},
  children: null
};
export { Popup as default };